<template>
    <div :class="[$prefixClass.card + '-stroke', 'block-plans']">
        <template v-if="isActualPage">
            <img class="m-b-24" src="@/assets/images/lock-actual.svg" alt="update-plan">
            <h5 class="m-b-8 font-weight-normal">{{$t('app.block_function.title')}}</h5>
            <h6 class="text-color-secondary m-b-20 font-weight-normal" v-html="$t('app.block_function.actual_lock_description')"></h6>
            <a-button type="primary" @click="$router.push({name: $routerName.PRICING})">{{$t('app.buttons.upgrade_now')}}</a-button><br>
        </template>
        <template v-else>
            <img class="m-b-24" src="@/assets/images/lock-perceived.svg" alt="update-plan">
            <h5 class="m-b-8 font-weight-normal">{{$t('app.block_function.title')}}</h5>
            <h6 class="text-color-secondary m-b-20 font-weight-normal" v-html="$t('app.block_function.perceived_lock_description')"></h6>
            <a-button type="primary" @click="$router.push({name: $routerName.PRICING})">{{$t('app.buttons.upgrade_now')}}</a-button><br>
        </template>
    </div>
</template>
<script>
    export default {
        name: "VueBlockFunction",
        props: {
            tutorialType: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                isLoading: false
            };
        },
        created() {
        },
        computed: {
            isActualPage() {
                return this.$router.currentRoute.name == this.$routerName.OPTIMIZE_IMAGE
            }
        },
        methods: {
        }
    };
</script>
<style lang="scss">
    .block-plans {
        padding: 24px;
        text-align: center;
    }
</style>